import { render, staticRenderFns } from "./MhModal.vue?vue&type=template&id=2b441e96"
import script from "./MhModal.vue?vue&type=script&lang=js"
export * from "./MhModal.vue?vue&type=script&lang=js"
import style0 from "./MhModal.vue?vue&type=style&index=0&id=2b441e96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports